import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=456921be&scoped=true"
import script from "./CategoryTree.vue?vue&type=script&lang=js"
export * from "./CategoryTree.vue?vue&type=script&lang=js"
import style0 from "./CategoryTree.vue?vue&type=style&index=0&id=456921be&prod&global=true&lang=scss"
import style1 from "./CategoryTree.vue?vue&type=style&index=1&id=456921be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456921be",
  null
  
)

export default component.exports